module.exports = __webpack_public_path__ + "img/distinction.260884cc.svg";